import { Injectable } from '@angular/core';
import {Jsonp, Http, Headers, URLSearchParams, Response} from '@angular/http';
import { Observable }     from 'rxjs/Observable';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import { EventsService } from '../EventsService';
import { EsriTasksService } from '../esriTasks/esriTasks-service';
import { MapService } from '../map-view/map.service';
import {Config} from '../config';
import MapView = require('esri/views/MapView');
import Geometry = require('esri/geometry/Geometry');
import PrintTask = require('esri/tasks/PrintTask');
import PrintTemplate = require('esri/tasks/support/PrintTemplate');
import PrintParameters = require('esri/tasks/support/PrintParameters');
import Print = require('esri/widgets/Print');
import FeatureLayer = require('esri/layers/FeatureLayer');
import Map = require('esri/Map');
import Basemap = require('esri/Basemap');
import Collection = require('esri/core/Collection');
import TileLayer = require('esri/layers/TileLayer');
import MapImageLayer = require('esri/layers/MapImageLayer');
import Graphic = require('esri/Graphic');
import SimpleFillSymbol = require('esri/symbols/SimpleFillSymbol');
import SimpleLineSymbol = require('esri/symbols/SimpleLineSymbol');
import Color = require('esri/Color');
import GraphicsLayer = require('esri/layers/GraphicsLayer');
import Extent = require('esri/geometry/Extent');
import LabelClass = require('esri/layers/support/LabelClass');
import TextSymbol = require('esri/symbols/TextSymbol');
import WatchUtils = require('esri/core/watchUtils');
import { castByValue } from '../../node_modules/@angular/core/src/linker/view_utils';

@Injectable()
export class ParcelReportService {
    appSettings:Object = null;
    private parcelBufferGeometry:Geometry;
    private mapView:MapView;
    parcelGeometry:Geometry;
    private parcelFeature:any;
    private textElementsPage1:string = "";
    private image1:string = "";
    private image2:string = "";
    private image3:string = "";
    private image4:string = "";
    private miLayer:MapImageLayer;
    private labelGraphicsLayer:GraphicsLayer = new GraphicsLayer();
    reportMapDiv:HTMLDivElement;
    inProcess:boolean = false;

    public activeProject:ReplaySubject<object> = new ReplaySubject(1);

    constructor(private _esriTasksService:EsriTasksService, private _mapService:MapService, private _eventsService:EventsService){
        if(this.appSettings == null){
            this.appSettings = Config.config[0];
        }
    }

    startParcelReport(parcelFeature:Object){
        this.inProcess = true;
        this.image1 = "";
        this.image2 = "";
        this.parcelFeature = parcelFeature;
        this.parcelGeometry = parcelFeature["geometry"];
        this._esriTasksService.bufferFeatures(this.appSettings["GeometryService"]["url"], [this.parcelGeometry], [200], "feet", this._mapService.view.spatialReference).then(geometries => {
                if(geometries.length > 0){
                    this.parcelBufferGeometry = geometries[0];
                    this.getTextValuesForReport();
                }
            }, error => {
                this.errorHandleFunction(error);
            });
    }

    private getTextValuesForReport(){
        var url:string = this.appSettings["ParcelReport"]["TextValuesPage1"]["url"];
        var layersObject:Object = this.appSettings["ParcelReport"]["TextValuesPage1"]["layersTexts"];
        var textElementsNames:Array<string> = [];
        var layersArray:Array<any> = [];
        for(var key in layersObject){
            textElementsNames.push(key);
            layersArray.push(layersObject[key]);
        }
        var centroidLocation:Object = {"X":this.parcelGeometry["centroid"].x, "Y":this.parcelGeometry["centroid"].y};
        //this._esriTasksService.soePolygonAnalysis(url, this.parcelGeometry["centroid"], layersArray, this.appSettings["Map"]["DefaultSpatialReference"]["wkid"], 'INTERSECTS').then(firstPageTextData => {
        //this._esriTasksService.getAPIPResultsByLocation(url, centroidLocation, this.appSettings["Map"]["DefaultSpatialReference"]["wkid"], layersArray).then(firstPageTextData => {
        this._esriTasksService.soePolygonAnalysis(url, this.parcelGeometry, layersArray, this.appSettings["Map"]["DefaultSpatialReference"]["wkid"], 'INTERSECTS').then(firstPageTextData => {
            if(firstPageTextData){
                this.processTextValuesForReportPage1(textElementsNames, firstPageTextData);
            }
        }, error => {
            console.log(error);
            this.setParcelReportActionToInit();
            alert("There was an error printing the document (zoning and land use). Please try again later.");
        })
    }

    private processTextValuesForReportPage1(textElementsNames:Array<string>, firstPageTextData:any){
        var textElementsObject:Object = new Object();
        if(firstPageTextData.data.Errors.length == 0){
            var resultLayers:Array<any> = firstPageTextData.data.ResultLayers;
            for(var i = 0; i < textElementsNames.length; i++){
                let records:Array<any> = resultLayers[i].Records;
                let resultArray:Array<string> = [];
                for(var record of records){
                    record.Values[0] == "" ? resultArray.push(this.appSettings["ParcelReport"]["TextValuesPage1"]["emptyStringValueDefault"]) : (resultArray.indexOf(record.Values[0]) == -1 ? resultArray.push(record.Values[0]) : null);
                }
                var textElValue:string = (resultArray.length > 0 ? resultArray.join('; ') : this.appSettings["ParcelReport"]["TextValuesPage1"]["emptyStringValueDefault"]);
                var customPage1Values:Object = this.appSettings["ParcelReport"]["TextValuesPage1"]["customValues"];
                if(customPage1Values.hasOwnProperty(textElementsNames[i]) && textElValue != this.appSettings["ParcelReport"]["TextValuesPage1"]["emptyStringValueDefault"]){
                    textElValue = customPage1Values[textElementsNames[i]];
                }
                textElementsObject[textElementsNames[i]] = textElValue;
            }
        }
        textElementsObject["ParcelNumber"] = this.parcelFeature.attributes["Parcel Number"];
        textElementsObject["ParcelAddress"] = this.parcelFeature.attributes["Parcel Address"];
        this.textElementsPage1 = JSON.stringify(textElementsObject);
        this.printMap1();
    }


    private generateLabelGraphic(labelSetting):Graphic{
        var textSymbol:TextSymbol = new TextSymbol();
        textSymbol.color = new Color(labelSetting["textSymbol"]["color"]);
        labelSetting["textSymbol"]["backgroundColor"] ? textSymbol.backgroundColor = new Color(labelSetting["textSymbol"]["backgroundColor"]) : null;
        labelSetting["textSymbol"]["haloColor"] ? textSymbol.haloColor = new Color(labelSetting["textSymbol"]["haloColor"]) : null;
        labelSetting["textSymbol"]["haloSize"] ? textSymbol.haloSize = labelSetting["textSymbol"]["haloSize"] : null;
        var textLabelSetting:string = (labelSetting["textSymbol"]["text"] as string);
        var labelText:string = (textLabelSetting.includes("{") && textLabelSetting.includes("}")) ? textLabelSetting.replace("{" + textLabelSetting.match(/\{(.*)\}/)[1] + "}", JSON.parse(this.textElementsPage1)[textLabelSetting.match(/\{(.*)\}/)[1]]) : (labelSetting["textSymbol"]["text"] as string);
        textSymbol.text = labelText.split(";").join("\n");
        var labelGraphic:Graphic = new Graphic({
            geometry: this.parcelGeometry["centroid"],
            symbol: textSymbol
        });
        return labelGraphic;
    }


    printMap1(){
        try{
            var layerCollection:Collection = new Collection();
            layerCollection.add(new TileLayer(this.appSettings["ParcelReport"]["BaseMap"]));
            this.miLayer = new MapImageLayer({
                "url":this.appSettings["ParcelReport"]["ZoningAndLandUseMapService"]["url"],
                "id":this.appSettings["ParcelReport"]["ZoningAndLandUseMapService"]["id"]
            });
            this.miLayer.watch("loadError", value => {
                    if(value != null){
                        this.errorHandleFunction(value);
                    }
                });
            
            this.miLayer.sublayers = new Collection([{id:0, "visible":true}, {id:1, "visible":false}]);
            layerCollection.add(this.miLayer);

            var lineSymbol:SimpleLineSymbol = new SimpleLineSymbol();
            lineSymbol.color = new Color([255, 0, 0]);
            lineSymbol.width = 2;
            var fillSymbol:SimpleFillSymbol = new SimpleFillSymbol();
            fillSymbol.color = new Color([0, 0, 0, 0.3]);
            fillSymbol.outline = lineSymbol;
            var parcelGraphic:Graphic = new Graphic({
                geometry: this.parcelGeometry,
                symbol: fillSymbol
            });
            var parcelGraphicLayer = new GraphicsLayer();
            parcelGraphicLayer.add(parcelGraphic);
            
            layerCollection.add(parcelGraphicLayer);
            layerCollection.add(this.labelGraphicsLayer);

            var labelGraphic:Graphic = null;
            this.appSettings["ParcelReport"]["ZoningAndLandUseMapService"]["labels"].forEach(element => {
                if(element["sublayerId"] == 0){
                    labelGraphic = this.generateLabelGraphic(element);
                    return;
                }
            });
            if(labelGraphic != null){
                this.labelGraphicsLayer.add(labelGraphic);
            }

            var map:Map = new Map({
                "layers":layerCollection
            });
            if(!this.mapView){
                this.mapView = new MapView({
                    map: map
                });
                
                this.reportMapDiv = document.createElement("div");
                let reportMapDivID:string = "reportMap" + Math.floor(Math.random() * 1000000000).toString();
                this.reportMapDiv.setAttribute("id", reportMapDivID);
                this.reportMapDiv.style.width = "500px";
                this.reportMapDiv.style.height = "320px";
                this.reportMapDiv.style.marginLeft = "-500px";
                document.body.appendChild(this.reportMapDiv);
                
                this.mapView.container = reportMapDivID;
                this.mapView.then(event => {
                    this.mapView.extent = this.parcelBufferGeometry.extent;
                    this.mapView.on("layerview-create", event => {
                        if(event.layer.id == "zoningAndLandUse"){
                            this.printMapsForZoningAndLandUse();
                        }else if(event.layer.id == "thoroughfares"){
                            this.printMapsForThoroughfares();   
                        }else if(event.layer.id == "bikeAndWalkways"){
                            this.getTextValuesForBikeAndWalkways();
                        }
                    }, error => {
                        this.errorHandleFunction(error);
                    });
                }, error => {
                    this.errorHandleFunction(error);
                });
            }else{
                this.mapView.set("map", map);
            }
        }catch(ex){
            this.errorHandleFunction(ex);
        }
    }

    private printMapsForZoningAndLandUse(){
        //this.mapView.extent = this.parcelBufferGeometry.extent;
        var printTask = new PrintTask(this.appSettings["ParcelReport"]["MapOnlyPrintService"]);
        var template = new PrintTemplate(
            new Object({
                "format":"png32",
                "exportOptions":{
                    "dpi":150,
                    "width":500,
                    "height":320
                },
                "layout":"map-only"
            })
        );
        var params:PrintParameters = new PrintParameters();
        params.view = this.mapView;
        params.template = template;
        printTask.execute(params).then(results => {
            console.log(results);
            let fileUrl:string = results.url;
            let fileName:string = fileUrl.substr(fileUrl.lastIndexOf("/") + 1);
            if(this.image1 == ""){
                this.image1 = fileUrl;
                this.miLayer.sublayers = new Collection([{id:0, "visible":false}, {
                    id:1, 
                    "visible":true
                }]);
                this.labelGraphicsLayer.graphics.removeAll();
                var labelGraphic:Graphic = null;
                this.appSettings["ParcelReport"]["ZoningAndLandUseMapService"]["labels"].forEach(element => {
                    if(element["sublayerId"] == 1){
                        labelGraphic = this.generateLabelGraphic(element);
                        return;
                    }
                });
                if(labelGraphic != null){
                    this.labelGraphicsLayer.add(labelGraphic);
                }

                this.printMapsForZoningAndLandUse();
                return;
            }
            this.image2 = fileUrl;
            this.startReportPage2();
        }, error => {
            console.log(error);
            this.setParcelReportActionToInit();
            alert("There was an error generating the document (polygon analysis for zoning and land use). Please try again later.");
        });
    }

    startReportPage2(){
        var layerCollection:Collection = new Collection();
        layerCollection.add(new TileLayer(this.appSettings["ParcelReport"]["BaseMap"]))
        this.miLayer = new MapImageLayer(this.appSettings["ParcelReport"]["ThoroughfareMapService"]);
        layerCollection.add(this.miLayer);

        var lineSymbol:SimpleLineSymbol = new SimpleLineSymbol();
        lineSymbol.color = new Color([255, 0, 0]);
        lineSymbol.width = 2;
        var fillSymbol:SimpleFillSymbol = new SimpleFillSymbol();
        fillSymbol.color = new Color([0, 0, 0, 0.3]);
        fillSymbol.outline = lineSymbol;
        var parcelGraphic:Graphic = new Graphic({
            geometry: this.parcelGeometry,
            symbol: fillSymbol
        });
        var parcelGraphicLayer = new GraphicsLayer();
        parcelGraphicLayer.add(parcelGraphic);
        layerCollection.add(parcelGraphicLayer);

        var map:Map = new Map({
            "layers":layerCollection
        });
        this.mapView.set("map", map);
    }

    printMapsForThoroughfares(){
        //this.mapView.extent = this.parcelBufferGeometry.extent;
        var printTask = new PrintTask({
            "url":this.appSettings["ParcelReport"]["ThoroughfarePrintService"]["url"]
        });
        var template = new PrintTemplate(
            new Object({
                "format":"png32",
                "layout":this.appSettings["ParcelReport"]["ThoroughfarePrintService"]["layout"],
                "layoutOptions":new Object({
                    "legendLayers":[]
                })
            })
        );
        var params:PrintParameters = new PrintParameters();
        params.view = this.mapView;
        params.template = template;
        printTask.execute(params).then(results => {
            console.log(results);
            let fileUrl:string = results.url;
            this.image3 = fileUrl;
            this.addBikesAndWalkwaysLayer();
        }, error => {
            console.log(error);
            this.setParcelReportActionToInit();
            alert("There was an error printing the document (thoroughfares). Please try again later.");
        });
    }

    addBikesAndWalkwaysLayer(){
        var currentLayers:Collection = this.mapView.map.layers;
        currentLayers.removeAt(1);
        this.miLayer = new MapImageLayer(
            this.appSettings["ParcelReport"]["BikeAndWalkwaysMapService"]);
        currentLayers.add(this.miLayer, 1);
    }

    private getTextValuesForBikeAndWalkways(){
        var url:string = this.appSettings["ParcelReport"]["TextValuesPage2"]["url"];
        var layersObject:Object = this.appSettings["ParcelReport"]["TextValuesPage2"]["layersTexts"];
        var textElementsNames:Array<string> = [];
        var layersArray:Array<any> = [];
        for(let key in layersObject){
            textElementsNames.push(key);
            layersArray.push(layersObject[key]);
        }
        this._esriTasksService.soePolygonAnalysis(url, this.parcelBufferGeometry, layersArray, this.appSettings["Map"]["DefaultSpatialReference"]["wkid"], 'INTERSECTS').then(secondPageTextData => {
            var printCustomTexts:Array<object> = [
                {"PedestrianPlanText":""},
                {"PedestrianPlanValues":""}
            ];
            if(secondPageTextData){
                var textElementsObject:Object = new Object();
                if(secondPageTextData.data.Errors.length == 0){
                    var resultLayers:Array<any> = secondPageTextData.data.ResultLayers;
                    for(var i = 0; i < textElementsNames.length; i++){
                        let records:Array<any> = resultLayers[i].Records;
                        if(records.length == 0){
                            continue;
                        }
                        let resultArray:Array<string> = [];
                        for(var record of records){
                            resultArray.push(record.Values[0]);
                        }
                        textElementsObject[textElementsNames[i]] = (resultArray.length > 0 ? resultArray.join('; ') : "");
                    }
                    for(let key in textElementsObject){
                        if(printCustomTexts[0]["PedestrianPlanText"] == ""){
                            printCustomTexts[0]["PedestrianPlanText"] = key;
                        }else{
                            printCustomTexts[0]["PedestrianPlanText"] = printCustomTexts[0]["PedestrianPlanText"] + "\r\n" + key;
                        }
                        if(printCustomTexts[1]["PedestrianPlanValues"] == ""){
                            printCustomTexts[1]["PedestrianPlanValues"] = textElementsObject[key];
                        }else{
                            printCustomTexts[1]["PedestrianPlanValues"] = printCustomTexts[1]["PedestrianPlanValues"] + "\r\n" + textElementsObject[key];
                        }
                    }
                }
            }
            this.printMapForBikeAndWalkways(printCustomTexts);
        });
    }

    printMapForBikeAndWalkways(printCustomTexts:Array<Object>){
        //this.mapView.extent = this.parcelBufferGeometry.extent;
        var printTask = new PrintTask({
            "url":this.appSettings["ParcelReport"]["BikeAndWalkwaysPrintService"]["url"]
        });
        var template = new PrintTemplate(
            new Object({
                "format":"png32",
                "layout":this.appSettings["ParcelReport"]["BikeAndWalkwaysPrintService"]["layout"],
                "layoutOptions":new Object({
                    "legendLayers":[],
                    "customTextElements":printCustomTexts
                })
            })
        );
        var params:PrintParameters = new PrintParameters();
        params.view = this.mapView;
        params.template = template;
        printTask.execute(params).then(results => {
            console.log(results);
            let fileUrl:string = results.url;
            this.image4 = fileUrl;
            this.createReport();
        }, error => {
            console.log(error);
            this.setParcelReportActionToInit();
            alert("There was an error printing the document (print bike and walkways). Please try again later.");
        });
    }

    private createReport(){
        var url:string = this.appSettings["ParcelReport"]["ParcelReportGPService"]["url"];
        this._esriTasksService.createReport(url, this.textElementsPage1, this.image1, this.image2, this.image3, this.image4).then(result => {
            console.log(result);
            this.setParcelReportActionToInit();
            try{
                if(result.data.results[0].value.url){
                    window.open(result.data.results[0].value.url, '_blank');
                }
            }catch(ex){
                alert("Error printing parcel report. Please try again later;");
            }
        }, error => {
            this.setParcelReportActionToInit();
            console.log(error);
            alert("Error printing parcel report (ReportGenerator service). Please try again later.");
        });
    }

    setParcelReportActionToInit(){
        document.body.removeChild(this.reportMapDiv);
        this.inProcess = false;
        this.mapView = null;
        this.activeProject.next({
            "status":"ready",
            "parcelNumber": this.parcelFeature["attributes"]["Parcel Number"]
        });
        return this.activeProject;
    }

    errorHandleFunction(error:any){
        document.body.removeChild(this.reportMapDiv);
        this.inProcess = false;
        this.mapView = null;
        this.activeProject.next({
            "status":"error", 
            "details":"ERROR! " + error.toString(),
            "parcelNumber": this.parcelFeature["attributes"]["Parcel Number"]
        });
        return this.activeProject;
    }
}


// WEBPACK FOOTER //
// ./app/tools/parcelReport.service.ts